import {observer} from "mobx-react-lite"
import React, {useEffect, useState} from "react"
import exportStatusController, {productStatus} from "./ExportStatusController"
import {SkeletonBox} from "../../lib/wa-2.0"
import {appPages} from "../../App"
import {Link, match} from "react-router-dom"

const ExportProductInfoComponent = observer(({match}: { match: match<{launch_id:string, index:string}> }) => {
    const launch_id = match.params.launch_id
    const product_index = match.params.index
    const product = exportStatusController.productsLoaded ? exportStatusController.products[Number(product_index)] : null



    const links =[]
    if(product) {

            links.push({
                url: window.location.origin+'/webasyst/ozon/offer-attributes/category/' + product.category_id,
                label: 'Характеристики категории'
            })

        links.push({
            url: window.location.origin+'/webasyst/shop/?action=products#/product/' + product.shop_product_id,
            label: 'Товар в Shop-script'
        })
        if (product.product_id != 0) {
            links.push({
                url: 'https://seller.ozon.ru/app/products/' + product.product_id + '/edit/general-info',
                label: 'Редактирование товара в Ozon'
            })
        }
    }

    return <div>
        <h1>6. Статус экспорта</h1>
        <Link  className="button" to={appPages.exportHistory + '/launch/' + launch_id}>Назад</Link>
        {product && <span style={{margin: '10px 70px', fontWeight:500}}>{product.name}</span>}
        {product ?
            <>
                <table>
                    <thead style={{backgroundColor: "#F3F3F3"}}>
                        <tr>
                            <th>Ошибка</th>
                            <th></th>
                            <th>Атрибут</th>
                        </tr>
                    </thead>
                    <tbody>
                        {product.errors.map((item, index) =>
                            <tr key={index}>
                                <td>{item.description}</td>
                                <td></td>
                                <td>{item.attribute_id != 0 ? item.attribute_name + '('+item.attribute_id+')' : '-'}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div>
                    {links.map((link, index) =>
                        <p key={index} style={{margin:'1em 0'}}>
                            <a target={'_blank'} href={link.url}>{link.label} <i className="fas fa-external-link-alt" aria-hidden="true"/></a>
                        </p>
                    )}
                </div>
            </> : <SkeletonBox/>}
    </div>
})


export default ExportProductInfoComponent